import React, { Fragment, useContext, useEffect } from "react";
import { useRoutes } from 'raviger';
import routes, { publicRoutes } from "./router";
import { ThemeProvider } from 'styled-components';
import { theme } from './theme';
import PageNotFound from "./components/PageNotFound";
import { useCookies, withCookies } from 'react-cookie';
import { AuthContext } from "./accounts/AccountsReducer";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "./components/Sidebar";

function Shelterly() {

  // Initial state.
  const { state, dispatch } = useContext(AuthContext);
  const [, , removeCookie] = useCookies(['token']);

  const routeResult = useRoutes(state.user ? routes : publicRoutes);

  const path = window.location.pathname;
  const organization = path.split('/')[1]

  const style = state.user && path !== '/' && path !== '/' + organization && !path.includes('/incident/') && !path.includes('/manage/') && (!path.includes('/accounts/') || path.includes('/userprofile/')) && !path.includes('/reset_password') ? {marginLeft:"330px"} : {};

  // Scroll to top of page after navigation.
  useEffect(() => {
     window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [path]);

  useEffect(() => {
    document.title = 'Shelterly';
  }, [state]);

  return (
    <ThemeProvider theme={theme}>
      <Container fluid>
        <Row>
          {state.user && path !== '/' && path !== '/' + organization && !path.includes('/incident/') && !path.includes('/manage/') && (!path.includes('/accounts/') || path.includes('/userprofile/')) && !path.includes('/reset_password') ?
            <Sidebar state={state} dispatch={dispatch} removeCookie={removeCookie} />
          : ""}
          {Object.keys(publicRoutes).includes(path) || (state && state.user && path === '/') || (state && state.organization.id && (path === '/' + organization) || path.includes('/accounts/') || path.includes('/incident/') || path.includes('/manage/')) || (state && state.organization.id && state.incident.id) ?
          <span className={state.user && path !== '/' && path !== '/' + organization && !path.includes('/incident/') && !path.includes('/manage/') && (!path.includes('/accounts/') || path.includes('/userprofile/')) && !path.includes('/reset_password') ? 'd-flex flex-column col-9 ps-0 pe-0' : 'd-flex flex-column col-12 ps-0 pe-0'} style={style}>
            <Fragment>
              {routeResult || <PageNotFound state={state} />}
            </Fragment>
          </span>
          : ""}
        </Row>
      </Container>
    </ThemeProvider>
  );
}

export default withCookies(Shelterly);
